import { useState } from "react";
import Preview from "../Preview/Preview";
import Ingredients from "../Ingredients/Ingredients";
import Directions from "../Directions/Directions";
import BottomMenu from "../BottomMenu/BottomMenu";
import { useTranslation } from "react-i18next";
import TagBadgesBar from "../TagBadgesBar/TagBadgesBar";

export interface IShowRecipe {
    id: number;
    userId?: number;
    username: string;
    description: string;
    ingredients: string;
    imageUrl: string;
    sourceUrl: string;
    name: string;
    preparationTime: number;
    isSplitViewDisabled: boolean;
    isPublic: boolean;
    hideUserRecipesButton: boolean;
    portionCount: number;
    triggerAction: (action: string) => void;
}

const ShowRecipe: React.FC<IShowRecipe> = (props) => {
    const { t } = useTranslation();
    const [ingredientsPosition, setIngredientsPosition] = useState(0);

    const handleIngredientsPosition = (height: number) => {
        setIngredientsPosition(height);
    };

    const bottomMenuAction = (action: string) => {
        props.triggerAction(action);
    };

    return (
        <div className="mt-2">
            <Preview
                name={props.name}
                isPublic={props.isPublic}
                image={props.imageUrl}
                isSplitViewDisabled={props.isSplitViewDisabled}
                portionCount={props.portionCount}
                preparationTime={props.preparationTime}
                ingredientsPosition={handleIngredientsPosition}
            />
            <TagBadgesBar isSplitViewEnabled={!props.isSplitViewDisabled} />
            <Ingredients
                ingredients={props.ingredients}
                isMobile={props.isSplitViewDisabled}
                position={ingredientsPosition}
            />
            <Directions description={props.description} isMobile={props.isSplitViewDisabled} />
            <BottomMenu
                userId={props.userId}
                triggerAction={bottomMenuAction}
                sourceUrl={props.sourceUrl}
                imageUrl={props.imageUrl}
                username={props.username}
                isSplitViewDisabled={props.isSplitViewDisabled}
                options={[
                    {
                        action: "USERNAME",
                        name: `@${props.username}`,
                        onlyForAuthorized: false,
                        icon: <i></i>,
                    },
                    {
                        action: "EDIT",
                        name: t("containers.editRecipePage.title"),
                        onlyForAuthorized: true,
                        icon: <i className="bi bi-pencil-square"></i>,
                    },
                    {
                        action: "DELETE",
                        name: t("containers.showRecipePage.delete"),
                        onlyForAuthorized: true,
                        icon: <i className="bi bi-trash3"></i>,
                    },
                ]}
            />
        </div>
    );
};

export default ShowRecipe;
